import { css } from 'styled-components';

export const breadcrumbWrapper = css`
  svg {
    height: 18px;
  }
`;